/**
 * Utility for programmatic form submission for GTM tracking purposes
 */

export interface FormSubmissionData {
  buttonId: string
  formData: Record<string, any>
  [key: string]: any
}

/**
 * Creates a hidden form and submits it programmatically for tracking purposes
 * This is useful for GTM and analytics tracking when users navigate between steps
 */
export const submitFormProgrammatically = (
  data: FormSubmissionData,
  handleNextStep: () => void,
  method: 'POST' | 'GET' = 'POST'
): void => {
  try {
    // Create a hidden form element
    const form = document.createElement('form')
    form.method = method
    form.action = '#'
    form.style.display = 'none'
    form.id = data.buttonId

    // Add form data as hidden inputs
    Object.entries(data).forEach(([key, value]) => {
      if (key === 'formData' && typeof value === 'object' && value !== null) {
        // Flatten formData fields as individual inputs
        Object.entries(value).forEach(([fieldKey, fieldValue]) => {
          const input = document.createElement('input')
          input.type = 'hidden'
          input.name = fieldKey
          input.value =
            typeof fieldValue === 'object'
              ? JSON.stringify(fieldValue)
              : String(fieldValue)
          form.appendChild(input)
        })
      } else {
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value =
          typeof value === 'object' ? JSON.stringify(value) : String(value)
        form.appendChild(input)
      }
    })

    // Add submit button with ID for tracking
    const submitButton = document.createElement('input')
    submitButton.type = 'submit'
    submitButton.id = data.buttonId
    submitButton.style.display = 'none'
    form.appendChild(submitButton)

    // Add submit event listener to call handleNextStep
    form.addEventListener('submit', (e) => {
      e.preventDefault()
      handleNextStep()
    })

    // Append form to body and submit
    document.body.appendChild(form)
    submitButton.click()

    // Clean up - remove form after submission
    // setTimeout(() => {
    //   if (document.body.contains(form)) {
    //     document.body.removeChild(form)
    //   }
    // }, 100)
  } catch (error) {
    console.warn('Failed to submit form programmatically for tracking:', error)
  }
}
